<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">滿意度調查</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:220px;">
            <div class="font-weight-bold">1.對此名單的滿意度為何?  (必填)</div>
            <div class="form-group mt-3">
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-1" :value="1">
                    <label for="satisfaction-type-1">非常不滿意</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-2" :value="2">
                    <label for="satisfaction-type-2">有點不滿意</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-3" :value="3">
                    <label for="satisfaction-type-3">不滿意</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-4" :value="4">
                    <label for="satisfaction-type-4">滿意</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-5" :value="5">
                    <label for="satisfaction-type-5">有點滿意</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="satisfaction" id="satisfaction-type-6" :value="6">
                    <label for="satisfaction-type-6">非常滿意</label>
                </div>
            </div>
            <div class="font-weight-bold">2.對此名單的建議(非必填)</div>
            <div class="form-group mt-3">
                <textarea class="form-control" cols="30" rows="5" maxlength="500" v-model="suggest" placeholder="建議字數上限500字"></textarea>
            </div>
            <div class="action text-right">
            <a @click.stop.prevent="close()" class="btn btn-default">
              關閉
            </a>
            <a @click.stop.prevent="submit()" class="btn btn-primary">
              回報
            </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import {setSatisfactionSurvey, setListAreaLog} from '@/service'

export default {
  name: 'SatisfactionModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data() {
      return {
          satisfaction: '',
          suggest: '',
          serno:'023'
      }
  },
  watch: {
    suggest(val) {
      this.suggest = this.cleanSpecialChar(val);
    },
  },
  methods: {
    submit() {
      setSatisfactionSurvey(this.$store.state.userInfo.id,this.$store.state.listAreaSerNo,this.satisfaction,this.suggest).then(result =>{
        if(result.header && result.header.status === '200') {
            this.$emit('report');
        } else {
            this.$toast.info({title: result.header.message})
        }
      })
      this.setLog()//新增名單專區Log
    },
    setLog(){
      setListAreaLog(this.$store.state.userInfo.id,this.$store.state.listAreaSerNo,"2").then(result => {
          if (result.header && result.header.status == '200') {
            console.log('新增成功')
          }else{
            console.error('新增名單專區log API 錯誤')
          }
      })
    },
    close() {
      this.$emit('close');
    }
  },
  computed: {
  },
}
</script>
